import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "./api";
import { useUserAuth } from "./userAuth";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useUserAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/", { replace: true });
      return;
    }
    const session_id = match[1];

    (async () => {
      try {
        await api.post("/auth/google/session", { session_id });
        await refresh();
        toast.success("Signed in with Google");
      } catch (e) {
        toast.error("Google sign-in failed");
      } finally {
        // Clean the URL fragment and go home
        window.history.replaceState(null, "", "/");
        nav("/", { replace: true });
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#F9F8F4]">
      <div className="text-center">
        <div className="w-12 h-12 rounded-full border-2 border-[#8C5931] border-t-transparent animate-spin mx-auto mb-4"/>
        <p className="text-sm text-[#6E6862]">Completing sign-in…</p>
      </div>
    </div>
  );
}
